(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-featured-grid"] && !Shopify.designMode) return;
  try {
    
  // Every tab's products are already in the page, so switching is a class of
  // work the network never sees.
  //
  // These are real tabs now, not the toggle buttons the style chips were, so
  // they carry the tab keyboard contract: arrows move between them, Home and
  // End jump to the ends, and only the selected tab is in the tab order
  // (CLAUDE.md §10).
  const selectTab = (section, tab) => {
    const tabs = [...section.querySelectorAll('[data-rf-tab]')];
    tabs.forEach((other) => {
      const on = other === tab;
      other.setAttribute('aria-selected', on ? 'true' : 'false');
      other.tabIndex = on ? 0 : -1;
    });

    section.querySelectorAll('[data-rf-panel]').forEach((panel) => {
      const on = panel.dataset.rfPanel === tab.dataset.rfTab;
      panel.hidden = !on;
      // In slider mode the panel that just appeared has whatever scroll
      // position it was left at.
      if (on) {
        const grid = panel.querySelector('.rf-featured__grid');
        if (grid) grid.scrollLeft = 0;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-rf-tab]');
    if (!tab) return;
    const section = tab.closest('.rf-featured');
    if (section) selectTab(section, tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-rf-tab]');
    if (!tab) return;
    const section = tab.closest('.rf-featured');
    if (!section) return;

    const tabs = [...section.querySelectorAll('[data-rf-tab]')];
    const here = tabs.indexOf(tab);
    let next = -1;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (here + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (here - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;

    event.preventDefault();
    selectTab(section, tabs[next]);
    tabs[next].focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-gauge"] && !Shopify.designMode) return;
  try {
    
  class RfGauge extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-rf-gauge-slider]');
      this.bar = this.querySelector('[data-rf-gauge-bar]');
      this.number = this.querySelector('[data-rf-gauge-number]');
      this.mm = this.querySelector('[data-rf-gauge-mm]');
      this.name = this.querySelector('[data-rf-gauge-name]');
      this.count = this.querySelector('[data-rf-gauge-count]');
      this.panels = [...this.querySelectorAll('[data-rf-gauge-panel]')];
      if (!this.slider || !this.panels.length) return;

      this.countTemplate = this.dataset.countTemplate || '';
      this.countTemplateOne = this.dataset.countTemplateOne || '';
      this.slider.addEventListener('input', () => this.apply());
      this.apply();
    }

    apply() {
      const panel = this.panels[Number(this.slider.value)];
      if (!panel) return;

      this.panels.forEach((p) => p.classList.toggle('is-active', p === panel));

      const mm = panel.dataset.mmDisplay;
      // The bar height is derived in CSS from the shared steel scale.
      this.bar.style.setProperty('--rf-bar-mm', panel.dataset.mm);
      if (this.number) this.number.textContent = mm;
      if (this.mm) this.mm.textContent = `${mm} mm`;
      if (this.name) this.name.textContent = panel.dataset.name || '';
      if (this.count) {
        const n = panel.dataset.count;
        // "1 pieces at 3.5 mm" was reaching the page. Nine of the fifteen
        // widths in the catalogue have one or two pieces, so this is the
        // common case, not an edge one.
        const template = n === '1' && this.countTemplateOne ? this.countTemplateOne : this.countTemplate;
        this.count.innerHTML = template.replace('[count]', `<b>${n}</b>`).replace('[mm]', mm);
      }
      this.slider.setAttribute('aria-valuetext', `${mm} mm`);
    }
  }

  if (!customElements.get('rf-gauge')) customElements.define('rf-gauge', RfGauge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-header"] && !Shopify.designMode) return;
  try {
    
  // Announcement countdown. Counts to the end of the "Last day" in the shop's
  // own time zone (offset passed from Liquid), recomputed from the clock on
  // every tick so a sleeping phone catches up at once. When it reaches zero the
  // whole bar hides, no reload needed.
  (() => {
    const timer = document.querySelector('[data-rf-countdown]');
    if (!timer) return;
    const bar = timer.closest('[data-rf-announce]');
    const raw = (timer.dataset.offset || '').replace(/[^+\-0-9]/g, '');
    const offset = /^[+-]\d{4}$/.test(raw) ? `${raw.slice(0, 3)}:${raw.slice(3)}` : '+00:00';
    const end = new Date(`${timer.dataset.end}T23:59:59${offset}`).getTime();
    if (Number.isNaN(end)) { timer.hidden = true; return; }
    const seg = (k) => timer.querySelector(`[data-cd-seg="${k}"]`);
    const pad = (n) => String(n).padStart(2, '0');
    let id = 0;
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        if (bar) bar.hidden = true;
        clearInterval(id);
        return;
      }
      const total = Math.floor(left / 1000);
      const d = Math.floor(total / 86400);
      const parts = { d, h: Math.floor((total % 86400) / 3600), m: Math.floor((total % 3600) / 60), s: total % 60 };
      Object.keys(parts).forEach((k) => {
        const el = seg(k);
        if (el) el.querySelector('b').textContent = pad(parts[k]);
      });
      const days = seg('d');
      if (days) days.hidden = d === 0;
      timer.classList.add('is-ready');
    };
    tick();
    id = setInterval(tick, 1000);
  })();

  // Desktop dropdowns. Hover and focus-within are handled entirely in CSS, so
  // the menus already work without this; the script adds the click toggle,
  // Escape, arrow-key movement, and the edge-flip measurement.
  (() => {
    const items = [...document.querySelectorAll('[data-rf-nav-item]')];
    if (!items.length) return;

    // dismissed = closed deliberately while focus is still inside, which only
    // Escape and the toggle can do. It suppresses the CSS :focus-within
    // opening until focus or the pointer genuinely leaves.
    const close = (item, dismissed) => {
      item.classList.remove('is-open');
      if (dismissed) item.classList.add('is-dismissed');
      item.querySelectorAll('[aria-expanded]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
    };
    const closeAll = (except) => items.forEach((i) => { if (i !== except) close(i); });

    const open = (item) => {
      closeAll(item);
      item.classList.remove('is-dismissed');
      item.classList.add('is-open');
      item.querySelectorAll('[aria-expanded]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
    };

    items.forEach((item) => {
      const toggle = item.querySelector('[data-rf-nav-toggle]');
      const trigger = item.querySelector('[data-rf-nav-trigger]');
      const links = [...item.querySelectorAll('[data-rf-nav-panel] a')];

      toggle.addEventListener('click', () => {
        item.classList.contains('is-open') ? close(item, true) : open(item);
      });

      // Hover is CSS, but aria-expanded has to follow it or the state a
      // screen reader is told never changes.
      item.addEventListener('mouseenter', () => open(item));
      item.addEventListener('mouseleave', () => { close(item); item.classList.remove('is-dismissed'); });

      item.addEventListener('keydown', (event) => {
        const i = links.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          close(item, true);
          trigger.focus();
          return;
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(item);
          links[i < 0 ? 0 : Math.min(i + 1, links.length - 1)]?.focus();
        }
        if (event.key === 'ArrowUp' && i > -1) {
          event.preventDefault();
          if (i === 0) { close(item, true); trigger.focus(); } else { links[i - 1].focus(); }
        }
      });

      // Tabbing out of the whole item closes it. focusout fires before the
      // new element takes focus, so the check is deferred a tick.
      item.addEventListener('focusout', () => {
        setTimeout(() => { if (!item.contains(document.activeElement)) { close(item); item.classList.remove('is-dismissed'); } }, 0);
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-rf-nav-item]')) closeAll();
    });

    // Flip any panel that would run past the right edge. Measured rather than
    // assumed, because it depends on the panel's own width and how far along
    // the bar its parent sits — the last item is not always the only one.
    const flip = () => {
      items.forEach((item) => {
        item.classList.remove('rf-nav-desktop__item--flip');
        const panel = item.querySelector('[data-rf-nav-panel]');
        if (!panel) return;
        if (panel.getBoundingClientRect().right > document.documentElement.clientWidth - 8) {
          item.classList.add('rf-nav-desktop__item--flip');
        }
      });
    };
    flip();
    window.addEventListener('resize', flip);
  })();

  class RfHeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.rf-drawer-btn');
      this.panel = this.querySelector('.rf-drawer');
      this.backdrop = this.querySelector('.rf-drawer__backdrop');
      this.closeButton = this.querySelector('.rf-drawer__close');

      this.button.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
    }

    open() {
      this.panel.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      const focusable = this.panel.querySelector('a, button');
      if (focusable) focusable.focus();
    }

    close() {
      this.panel.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      this.button.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      const focusables = this.panel.querySelectorAll('a, button, summary');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('rf-header-drawer')) {
    customElements.define('rf-header-drawer', RfHeaderDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-product"] && !Shopify.designMode) return;
  try {
    
  class RfProduct {
    constructor(root) {
      this.root = root;
      this.bindFit();
      this.bindSticky();
      this.bindStickyOptions();
      this.bindFitJump();
    }

    // "See it worn" beside the length picker. The href is a real anchor, so
    // this only upgrades the jump to a smooth one — with scripts off, or if
    // anything here throws, the link still works.
    bindFitJump() {
      const jump = this.root.querySelector('[data-rf-fit-jump]');
      if (!jump) return;

      jump.addEventListener('click', (event) => {
        const target = this.root.querySelector(jump.getAttribute('href'));
        if (!target) return;
        event.preventDefault();

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const start = window.scrollY;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

        // Because the default is prevented, a smooth scroll that quietly does
        // nothing would leave the link dead rather than merely unanimated —
        // and there are environments where the animation never runs. If the
        // page has not begun moving shortly after, jump it there outright.
        if (!reduced) {
          setTimeout(() => {
            if (Math.abs(window.scrollY - start) < 2) {
              target.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
          }, 250);
        }

        // Worth setting either way: it keeps the position shareable and gives
        // the back button something to return to.
        history.replaceState(null, '', jump.getAttribute('href'));
      });
    }

    // Length picker in the sticky bar, so a shopper past the buy panel can
    // change it without scrolling back up.
    bindStickyOptions() {
      const bar = this.root.querySelector('[data-rf-sticky]');
      const selects = this.root.querySelector('variant-selects');
      const info = this.root.querySelector('product-info');
      if (!bar || !selects) return;

      const pickers = [...bar.querySelectorAll('[data-rf-sticky-option]')];
      if (!pickers.length) return;

      // Re-queried on every read, never captured. Dawn re-renders
      // variant-selects' inner markup through the Section Rendering API on
      // each change, replacing these inputs with new nodes — the same thing
      // that broke the fit grid's first implementation, where a set captured
      // at load silently went stale after the first change.
      const radiosFor = (name) =>
        [...this.root.querySelectorAll('variant-selects input[type="radio"]')].filter(
          (input) => input.dataset.optionName === name
        );

      pickers.forEach((picker) => {
        picker.addEventListener('change', () => {
          const target = radiosFor(picker.dataset.optionName).find(
            (input) => input.value === picker.value
          );
          if (!target || target.disabled) return;
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      const sync = () => {
        pickers.forEach((picker) => {
          const radios = radiosFor(picker.dataset.optionName);
          const current = radios.find((input) => input.checked);
          if (current && picker.value !== current.value) picker.value = current.value;
          // Carry sold-out state across, so the bar cannot offer a length the
          // buy panel has already greyed out.
          [...picker.options].forEach((option) => {
            const radio = radios.find((input) => input.value === option.value);
            if (radio) option.disabled = radio.disabled;
          });
        });

        const price = this.root.querySelector('[id^="price-"]');
        const stickyPrice = bar.querySelector('[data-rf-sticky-price]');
        if (price && stickyPrice) stickyPrice.innerHTML = price.innerHTML;
      };

      // Bound to this.root, not to <variant-selects>. Dawn replaces that whole
      // element on re-render — measured, not assumed — so a listener attached
      // to it stops firing after the first change and the bar silently stops
      // following the buy panel. this.root is never re-rendered, and change
      // events bubble up to it.
      this.root.addEventListener('change', (event) => {
        // Ignore the bar's own pickers: their handler above is already
        // driving the radios, and syncing from a not-yet-updated radio here
        // would snap the shopper's choice back.
        if (event.target.closest('[data-rf-sticky-option]')) return;
        sync();
      });

      // A MutationObserver as well, because Dawn's re-render is a fetch: on
      // 'change' the price node still holds the old value. Watching
      // product-info catches the markup actually landing. The bar sits
      // outside product-info, so nothing here retriggers the observer.
      //
      // setTimeout, not requestAnimationFrame — rAF does not fire in a
      // background tab, which would leave the bar stale for anyone who
      // switches away mid-change and back.
      if (info) {
        let queued = false;
        new MutationObserver(() => {
          if (queued) return;
          queued = true;
          setTimeout(() => {
            queued = false;
            sync();
          }, 0);
        }).observe(info, { childList: true, subtree: true });
      }
      sync();
    }

    // Clicking a fit photo selects that length in the buy panel, which is what
    // fires Dawn's variant change.
    bindFit() {
      const grid = this.root.querySelector('[data-rf-fit]');
      const selects = this.root.querySelector('variant-selects');
      if (!grid || !selects) return;

      const cells = [...grid.querySelectorAll('[data-fit-length]')];

      // Re-queried live, not captured once. Dawn's own variant-change handling
      // re-renders <variant-selects>' own markup (through the Section
      // Rendering API) the first time a selection changes, which replaces
      // these radio inputs with new nodes. A set captured once at construction
      // goes stale the moment that first re-render happens: syncPressed() then
      // keeps searching a detached, frozen copy of the fieldset, so every
      // click after the first quietly stops working in both directions.
      // grid's own cells are this component's own static markup, never
      // touched by Dawn, so they are safe to capture once.
      //
      // Queried from this.root rather than through the captured `selects`:
      // Dawn replaces the <variant-selects> element itself, not just its
      // contents, so anything held against that element goes stale too.
      const getInputs = () => [
        ...this.root.querySelectorAll('variant-selects input[type="radio"]'),
      ];

      const syncPressed = () => {
        const current = getInputs().find((i) => i.checked);
        cells.forEach((cell) => {
          const match = current && cell.dataset.fitLength.trim() === current.value.trim();
          cell.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      };

      cells.forEach((cell) => {
        cell.addEventListener('click', () => {
          const wanted = cell.dataset.fitLength.trim();
          const input = getInputs().find((i) => i.value.trim() === wanted && !i.disabled);
          if (!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          syncPressed();
          const live = this.root.querySelector('variant-selects');
          if (live) live.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });

      // On this.root, not on <variant-selects>, for the same reason as above —
      // that element is replaced on re-render and takes its listeners with it,
      // which would leave the pressed state frozen after the first change.
      this.root.addEventListener('change', syncPressed);
      syncPressed();
    }

    // Sticky bar appears once the real add button has scrolled out of view.
    bindSticky() {
      const bar = this.root.querySelector('[data-rf-sticky]');
      const submit = this.root.querySelector('.product-form__submit');
      if (!bar || !submit) return;

      bar.hidden = false;
      bar.querySelector('[data-rf-sticky-add]').addEventListener('click', () => submit.click());

      // Only once the button has scrolled off the TOP. Testing isIntersecting
      // alone would show the bar before the shopper has even reached the real
      // button, since it starts below the fold on a phone.
      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        },
        { threshold: 0 }
      );
      observer.observe(submit);
    }
  }

  document.querySelectorAll('.rf-product').forEach((root) => new RfProduct(root));

  // Next dispatch day: skip the weekend, roll over once the cut-off has passed.
  // Everything is worked out in the shop's timezone rather than the visitor's,
  // or a Melbourne cut-off would fire at the wrong hour for anyone overseas.
  document.querySelectorAll('[data-rf-dispatch]').forEach((el) => {
    const zone = el.dataset.timezone || 'Australia/Melbourne';
    const cutoff = parseInt(el.dataset.cutoff, 10);
    const line = el.querySelector('[data-rf-dispatch-line]');
    if (!line) return;

    const partsIn = (date) => {
      const fmt = new Intl.DateTimeFormat('en-AU', {
        timeZone: zone,
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        hour12: false,
      });
      const out = {};
      fmt.formatToParts(date).forEach((p) => (out[p.type] = p.value));
      return out;
    };

    try {
      const now = new Date();
      const here = partsIn(now);
      let cursor = new Date(now);

      // Past the cut-off, today is already gone.
      if (!Number.isNaN(cutoff) && parseInt(here.hour, 10) >= cutoff) {
        cursor.setDate(cursor.getDate() + 1);
      }
      // Then walk forward off Saturday and Sunday.
      for (let guard = 0; guard < 7; guard += 1) {
        const day = partsIn(cursor).weekday;
        if (day !== 'Sat' && day !== 'Sun') break;
        cursor.setDate(cursor.getDate() + 1);
      }

      const long = el.dataset.dateFormat === 'long';
      const label = new Intl.DateTimeFormat('en-AU', {
        timeZone: zone,
        weekday: long ? 'long' : 'short',
        day: 'numeric',
        month: long ? 'long' : 'short',
      }).format(cursor);

      line.innerHTML = (el.dataset.template || '').replace('[date]', `<b>${label}</b>`);
    } catch (e) {
      // Leave the fallback copy in place rather than showing a broken date.
      console.error(e);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-stacks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rf-stack-add]');
    if (!button) return;

    const ids = (button.dataset.variants || '').split(',').filter(Boolean);
    const drawer = document.querySelector('cart-drawer');
    if (!ids.length || !drawer) return;

    const card = button.closest('.rf-stacks__card');
    const errorBox = card ? card.querySelector('[data-rf-stack-error]') : null;
    if (errorBox) errorBox.hidden = true;
    button.setAttribute('aria-disabled', 'true');

    const body = JSON.stringify({
      items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
      sections: drawer.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsed) => {
        // /cart/add.js rejects the whole request if any one line fails, so a
        // sold-out piece must be reported rather than silently dropped.
        if (parsed.status) {
          if (errorBox) {
            errorBox.textContent = parsed.description || parsed.message;
            errorBox.hidden = false;
          }
          return;
        }
        drawer.renderContents(parsed);
      })
      .catch((e) => console.error(e))
      .finally(() => button.removeAttribute('aria-disabled'));
  });

  } catch(e) { console.error(e); }
})();
})();
